import PusherService from '@/app/services/PusherService';

/**
 * 탭 비활성/활성 전환 시 stale UI 및 메시지 race 를 방지한다.
 *
 * - 탭이 비활성화되면 Pusher 연결을 끊어 백그라운드에서 store 가 갱신되는 것을 차단한다.
 * - 다시 활성화되면 무조건 페이지를 새로고침해 서버에서 최신 state 를 다시 받는다.
 *
 * (DKT-1026)
 */
export function setupTabVisibilityRefresh(): void {
    if (typeof document === 'undefined') {
        return;
    }

    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
            PusherService.getInstance().unsubscribeClassChannel();
            return;
        }

        if (document.visibilityState === 'visible') {
            window.location.reload();
        }
    });
}
